<template class="main-container">
  <v-container>
    <v-row class="main-container">
      <v-col>
        <v-expansion-panels accordion v-model="panel" max-width="1000">
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 0 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon>
              </template>
              EDIT YOUR ACCOUNT</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <EditAccount @nextSection="nextSection()" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 1 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >PROFILE AND COVER PHOTO</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <EditProfileInfo :section="sections().EDIT_YOUR_INFORMATION" @nextSection="nextSection()" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 2 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >PROOF OF CERTIFICATION</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <EditProfileInfo :section="sections().PROOF_OF_CERTIFICATION" @nextSection="nextSection()" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 3 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >CATEGORIES AND TAGS</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <EditProfileInfo
                v-if="panel == 3"
                :section="sections().CATEGORIES_AND_TAGS"
                @nextSection="nextSection()"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 4 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >MEDIA LIBRARY</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <Library />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 5 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >ABOUT YOUR PRACTICE</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <EditProfileInfo :section="sections().ABOUT_YOUR_PRACTICE" @nextSection="nextSection()" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 6 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >FOR IN-PERSON MEETINGS</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <EditProfileInfo :section="sections().FOR_IN_PERSON_MEETINGS" @nextSection="nextSection()" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 7 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >SOCIAL MEDIA</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <EditProfileInfo :section="sections().SOCIAL_MEDIA" @nextSection="nextSection()" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 8 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >APPOINTMENT INFORMATION</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <EditProfileInfo :section="sections().APPOINTMENT_INFORMATION" @nextSection="nextSection()" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 9 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >SET YOUR SCHEDULE</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <WorkingDays />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title">
              <template v-slot:actions>
                <v-icon>
                  {{ panel != 10 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >PRODUCTS</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <ProductsList />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="list-title" style="text-transform: uppercase"
              ><template v-slot:actions>
                <v-icon>
                  {{ panel != 11 ? 'mdi-plus' : 'mdi-close' }}
                </v-icon> </template
              >Traumatic Experience</v-expansion-panel-header
            >

            <v-expansion-panel-content>
              <ask-questions
                :currentQuestion="question"
                title="Have you overcome any of these traumatic events or have experience with working with people in these areas? Please select all that apply:"
                @nextSection="nextSection()"
                @cancelAskQuestion="cancelAskQuestion"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
/* eslint-disable no-debugger */

import EditAccount from './EditAccount';
import WorkingDays from './WorkingDays';
import ProductsList from '../product/ProductsList.vue';
import Library from './Library';
import EditProfileInfo from './EditProfileInfo';
import questionsStore from '@/components/member/questionsStore';
import loginStore from '@/util/loginStore';

import EditProfileSections from './EditProfileSections';
import API from '../../api';

export default {
  name: 'EditProfileTabbar',
  props: {},
  data: () => ({
    tab: '',
    panel: -1,
    question: {}
  }),
  components: {
    EditProfileInfo,
    Library,
    ProductsList,
    WorkingDays,
    EditAccount
    //Matching,
    //Tags,
  },
  async created() {
    await questionsStore.created();
    await this.loadData();
    if (this.$route.query.panel) {
      this.panel = parseInt(this.$route.query.panel);
    }
  },
  methods: {
    isProfessional() {
      return loginStore.isProfessional;
    },
    sections() {
      return EditProfileSections;
    },
    nextSection() {
      setTimeout(() => {
        this.panel = this.panel + 1;
      }, 300);
    },
    async cancelAskQuestion() {
      await questionsStore.created();
      this.panel = -1;
    },
    async loadData() {
      let res = await API.get('question?type=traumatic');
      if (res.data) {
        this.question = res.data.question;
      }
    }
  }
};
</script>
<style>
.main-container {
  font-family: 'Nunito', sans-serif !important;
}
.name-profile {
  font-size: 24px;
}
.title-text {
  font-size: 15px !important;
}
.blue-text {
  letter-spacing: 0.3px;
  opacity: 0.8;
  color: #6596b2;
  font-size: 15px;
  font-weight: 700;
}
.bolder {
  font-weight: bolder;
}
.avatar2 {
  width: 140px !important;
  height: 140px !important;
  top: 0px !important;
  left: 30px !important;
  border: 5px solid #fff;
}
.filepond--item {
  width: calc(50% - 0.5em);
}
.v-icon.outlined {
  background-color: white;
  height: 50px;
  width: 50px;
}
.img {
  background: rgba(0, 0, 0, 0.5);
  height: 400px;
  cursor: pointer;
}
.text-image {
  color: #fff;
  text-shadow: 0 1px #666;
  cursor: pointer;
  line-height: 21px;
  font-size: 16px;
}
.v-textarea textarea {
  max-height: none;
  height: 32px;
}
.list-title {
  color: #428751;
  font-family: 'Nunito', sans-serif !important;
  font-weight: bold;
  font-size: 18px !important;
  /*border-color: unset !important;*/
  border-bottom: 1px solid #ffffff;
}
</style>
